import React from 'react';
import { AssetUrls } from 'config/assets';
import { CARD_BACK_DATA_URI } from 'utils/cardImageFallback';

// Fixed CDN fallbacks (decision 9) when the viewer has no have/want samples.
// CDN only — an api.scryfall.com URL anywhere in this feature is a defect.
const FALLBACK_HAVE_SCRYFALL_ID = '6580f4f9-870b-4258-8dce-48c606b90a6c'; // Lightning Bolt
const FALLBACK_WANT_SCRYFALL_ID = '00020b05-ecb9-4603-8cc1-8cfa7a14befc'; // Wildcall

interface SwapDiagramProps {
  /** A card from the viewer's have list, when available */
  haveScryfallId?: string | null;
  /** A card from the viewer's want list, when available */
  wantScryfallId?: string | null;
}

/**
 * The diagram that teaches the mechanic at a glance: two floating cards with
 * orbit rings, a pulsing swap axis, and solid pill labels — YOU SEND (magenta,
 * leaving you) / THEY SEND (violet, coming to you). Motion is CSS-only and
 * fully suppressed under prefers-reduced-motion: reduce.
 */
const SwapDiagram: React.FC<SwapDiagramProps> = ({ haveScryfallId, wantScryfallId }) => {
  const sendSrc = AssetUrls.cards.getCardImage(haveScryfallId || FALLBACK_HAVE_SCRYFALL_ID, 'normal');
  const getSrc = AssetUrls.cards.getCardImage(wantScryfallId || FALLBACK_WANT_SCRYFALL_ID, 'normal');

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (e.currentTarget.src !== CARD_BACK_DATA_URI) {
      e.currentTarget.src = CARD_BACK_DATA_URI;
    }
  };

  return (
    <div className="offers-swap" aria-hidden="true">
      <div className="offers-swap-ring" />
      <div className="offers-swap-ring offers-swap-ring--outer" />
      <div className="offers-swap-glow" />
      <div className="offers-swap-cards">
        <div className="offers-swap-card offers-swap-card--you">
          <img src={sendSrc} alt="" loading="lazy" onError={handleError} />
          <div className="offers-swap-label">YOU SEND</div>
        </div>
        <div className="offers-swap-axis">
          <span>⇄</span>
        </div>
        <div className="offers-swap-card offers-swap-card--them">
          <img src={getSrc} alt="" loading="lazy" onError={handleError} />
          <div className="offers-swap-label">THEY SEND</div>
        </div>
      </div>
    </div>
  );
};

export default SwapDiagram;
